import { forwardRef } from 'react'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', disabled, ...props }, ref) => {
    const hasError = !!error

    return (
      <div className={`flex flex-col w-full ${label ? 'mb-5' : ''}`}>
        {label && (
          <label className={`enrollment-field-label ${hasError ? '!text-error' : ''}`}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          disabled={disabled}
          className={`enrollment-field-control ${hasError ? 'enrollment-field-control--error' : ''} ${className}`}
          {...props}
        />
        {error && <span className="text-xs text-error mt-1.5 flex items-center gap-1">{error}</span>}
      </div>
    )
  }
)

Input.displayName = 'Input'
